import PropTypes from 'prop-types'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'
import { isNilOrEmpty } from 'ramdasauce'
import cn from 'classnames'

import { useStyles } from './styles'
import { Animated, Text } from 'components/atoms'

export const Video = ({ youtubeLink, title, backgroundColor }) => {
  const classes = useStyles()

  const splitLink = !isNilOrEmpty(youtubeLink) && youtubeLink.split('=')
  const videoId = splitLink[1]

  const wrapperClasses = cn({
    [classes.wrapper]: true,
    [classes.lightBlue]: backgroundColor,
  })
  const titleClasses = cn({
    [classes.title]: true,
    [classes.white]: backgroundColor,
  })

  return (
    <div className={wrapperClasses}>
      <div className={classes.container}>
        {!isNilOrEmpty(title) && (
          <Animated type="fade-in">
            <div className={titleClasses}>
              <Text size="header1" tag="h3">
                {title}
              </Text>
            </div>
          </Animated>
        )}
        <Animated>
          <div>
            <LiteYouTubeEmbed
              id={videoId}
              poster="maxresdefault"
              playerClass={classes.playButton}
            />
          </div>
        </Animated>
      </div>
    </div>
  )
}

Video.propTypes = {
  text: PropTypes.string,
}

Video.defaultProps = {
  text: 'Video',
}
